import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useState } from 'react';

import InformationSubMenu from '@/components/nav/InformationSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const Form1099NewJersey = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Extend your business tax return deadline with Form 7004.`,
  //   SubHeading:
  //     'E-file now and get more time to ensure accuracy. File now for peace of mind.',
  //   CtaText: 'E-file Form 7004 Now',
  //   CtaSubHeading: `Takes 3 steps and less than 5 minutes`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };

  return (
    <AppLayout
      //  LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="E-File New Mexico 1099 Forms Quickly and Securely - TaxZerone"
          description="E-File your New Mexico 1099 forms for just $0.99 each. Quick, secure, and fully compliant with state tax requirements. Start e-filing today with TaxZerone!"
          keywords=" "
          canonical="form-1099-state-filing/new-mexico-filing-requirements/"
          jsonLdPricing="0.99"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="57448"
          ogShareImg="assets/images/information-share-img.png"
        />
      }
    >
      <InformationSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />

      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Final Day to E-File Form W-2!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Don&apos;t miss the deadline! Today is the <b>Last Day</b> to
              Submit Your <b>Form W-2</b> Electronically!
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      <Container maxWidth="xl" component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/1099-nm-landing-img.webp" />
                <source srcSet="/assets/images/1099-nm-landing-img.png" />
                <img
                  src="/assets/images/1099-nm-landing-img.png"
                  alt="E-File Your New Mexico 1099 Forms With Ease"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>

          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                E-File Your{' '}
                <span className="highlight-container">
                  <span className="highlight">New Mexico</span>
                </span>{' '}
                1099 Forms With Ease
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                TaxZerone simplifies 1099 filing for the 2025 tax year. Stay
                compliant with state New Mexico’s requirements and file securely
                in minutes.
              </Typography>
              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099nm`}
                  >
                    Start Filing Now!{' '}
                    {/* <Box
                      component={'span'}
                      sx={{ ml: 1, color: '#eaff00', fontWeight: 700 }}
                    >
                      Your W-2 Today!
                    </Box> */}
                  </Button>
                </Box>
              </Stack>
            </Box>
          </Box>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/1099-nm-landing-img-sm.webp" />
                <source srcSet="/assets/images/1099-nm-landing-img-sm.png" />
                <img
                  src="/assets/images/1099-nm-landing-img-sm.png"
                  alt="E-File Your New Mexico 1099 Forms With Ease"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 3, md: 3, lg: 3 },
            borderRadius: { xs: 0, md: 4 },
            mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          className="gradient-bg"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 3 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Box sx={{ width: '100%' }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 30, sm: 26, xs: 22 },
                  fontWeight: 500,
                  mb: 0,
                  textAlign: 'left',
                  lineHeight: 1.5,
                }}
              >
                Affordable Pricing
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 22, md: 20, sm: 18, xs: 16 },
                  fontWeight: 400,
                  color: '#f3f3f3',
                  mb: 0,
                  textAlign: 'left',
                }}
              >
                E-File your New Mexico 1099 forms for just{' '}
                <Box
                  component="strong"
                  sx={{
                    color: '#ffe400',
                    fontSize: { xs: 24, sm: 22 },
                  }}
                >
                  $0.99 per form
                </Box>{' '}
                —simple, transparent, and budget-friendly!
              </Typography>
            </Box>
            <Box
              sx={{
                width: '100%',
                maxWidth: { xs: '100', sm: 250, md: 280 },
                textAlign: 'center',
                fontSize: 18,
                lineHeight: 1.2,
              }}
            >
              <Button
                size="large"
                variant="contained"
                href="/pricing/#informationreturns"
                sx={{
                  boxShadow: 'none',
                  borderRadius: 2,
                  mb: 0.5,
                  textTransform: 'none',
                  backgroundColor: '#fff',
                  color: '#0a7581',
                  '&:hover, &:focus, &:active': {
                    color: '#fff',
                    backgroundColor: '#172b6b',
                  },
                }}
              >
                See Pricing
              </Button>
              {/* <Typography
                variant="body2"
                sx={{ mt: 0, mb: 0, fontSize: { xs: 11, sm: 14 } }}
              >
                For your return volume
              </Typography> */}
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Container
        component="section"
        maxWidth="lg"
        sx={{ pt: 6, pb: 6, textAlign: 'center' }}
      >
        <Grid container spacing={2} sx={{ pt: 2, pb: 2 }}>
          <Grid size={12} sx={{ textAlign: 'center' }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: { md: 3, sm: 1, xs: 0 },
                pt: { md: 0, sm: 3 },
                textAlign: { md: 'center', sm: 'center' },
              }}
            >
              New Mexico 1099 Filing Requirements
            </Typography>
            <Typography
              variant="body1"
              id="nec"
              sx={{ mb: { md: 3, sm: 3, xs: 16 } }}
            >
              Stay compliant with New Mexico&apos;s 1099 filing requirements by
              understanding the required forms, reporting thresholds,{' '}
              <Hidden smDown>
                <br />
              </Hidden>
              submission methods, and deadlines. Ensure accurate and timely
              filing for:
            </Typography>
            <Hidden smDown>
              <Stack
                direction="row"
                spacing={2}
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  maxWidth: '100%',
                  alignSelf: 'center',
                  m: 0,
                }}
              >
                <Link href="#nec" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      1099-NEC
                    </Typography>
                  </Paper>
                </Link>
                <Link href="#misc" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      1099-MISC
                    </Typography>
                  </Paper>
                </Link>
                <Link href="#1099b" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      1099-B
                    </Typography>
                  </Paper>
                </Link>
                <Link href="#div" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      1099-DIV
                    </Typography>
                  </Paper>
                </Link>
                <Link href="#1099g" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      1099-G
                    </Typography>
                  </Paper>
                </Link>
                <Hidden mdDown>
                  <Link href="#int" sx={{ textDecoration: 'none' }}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                    >
                      <Typography
                        variant="h4"
                        sx={{ fontSize: '14px !important', fontWeight: 600 }}
                      >
                        1099-INT
                      </Typography>
                    </Paper>
                  </Link>
                  <Link href="#1099k" sx={{ textDecoration: 'none' }}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                    >
                      <Typography
                        variant="h4"
                        sx={{ fontSize: '14px !important', fontWeight: 600 }}
                      >
                        1099-K
                      </Typography>
                    </Paper>
                  </Link>
                  <Link href="#oid" sx={{ textDecoration: 'none' }}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                    >
                      <Typography
                        variant="h4"
                        sx={{ fontSize: '14px !important', fontWeight: 600 }}
                      >
                        1099-OID
                      </Typography>
                    </Paper>
                  </Link>
                  <Link href="#1099r" sx={{ textDecoration: 'none' }}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                    >
                      <Typography
                        variant="h4"
                        sx={{ fontSize: '14px !important', fontWeight: 600 }}
                      >
                        1099-R
                      </Typography>
                    </Paper>
                  </Link>
                  <Link href="#w2g" sx={{ textDecoration: 'none' }}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                    >
                      <Typography
                        variant="h4"
                        sx={{ fontSize: '14px !important', fontWeight: 600 }}
                      >
                        W-2G
                      </Typography>
                    </Paper>
                  </Link>
                </Hidden>
              </Stack>
            </Hidden>
            <Hidden mdUp smDown>
              <Stack
                direction="row"
                spacing={2}
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  maxWidth: '100%',
                  mt: 2,
                }}
              >
                <Link href="#int" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      1099-INT
                    </Typography>
                  </Paper>
                </Link>
                <Link href="#1099k" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      1099-K
                    </Typography>
                  </Paper>
                </Link>
                <Link href="#oid" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      1099-OID
                    </Typography>
                  </Paper>
                </Link>
                <Link href="#1099r" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      1099-R
                    </Typography>
                  </Paper>
                </Link>
                <Link href="#w2g" sx={{ textDecoration: 'none' }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2, borderRadius: 2, textAlign: 'center' }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ fontSize: '14px !important', fontWeight: 600 }}
                    >
                      W-2G
                    </Typography>
                  </Paper>
                </Link>
              </Stack>
            </Hidden>
          </Grid>
          <Grid
            size={12}
            sx={{
              textAlign: 'center',
              mb: 4,
              position: { xs: 'relative', sm: 'static' },
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: { xs: 'flex', sm: 'grid', md: 'grid' },
                gridTemplateColumns: 'auto auto ',
                columnGap: 1,
                placeContent: 'start',
                m: { xs: 3, sm: 0 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: '#efefef',
                  height: 150,
                  width: 150,
                  position: { xs: 'absolute', sm: 'relative', md: 'relative' },
                  left: { md: 55, sm: 40, xs: 90 },
                  zIndex: 2,
                  top: { xs: -80, sm: 0 },
                  p: 3,
                  m: '0',
                  boxShadow:
                    'rgba(154, 154, 163, 0.25) 0px 30px 50px -12px inset, rgba(255, 255, 255, 0.1) 0px 18px 26px -18px inset',
                }}
              >
                <Box
                  sx={{
                    width: '34px !important',
                    height: '27px !important',
                    m: 'auto',
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    mb: 0.5,

                    '& .state-flag': {
                      height: '100%',
                      width: '100%',
                    },
                  }}
                >
                  <img
                    srcSet="/assets/images/state-flag/new-mexico-flag.svg"
                    loading="lazy"
                    alt="new mexico"
                    width="100%"
                    height="100%"
                    className="state-flag"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 700,
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 0,
                  }}
                >
                  1099-NEC
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#f0f3ff',

                  borderRadius: 4,
                  justifyContent: { xs: 'center' },
                  position: 'relative',
                  width: { xs: 331, sm: 'auto' },
                  right: { xs: 23, sm: 'auto' },
                }}
              >
                <Box
                  component="div"
                  sx={{ mb: 0, mx: 4, position: 'relative' }}
                  className="rectange-state rectange-state-left"
                >
                  <TableContainer
                    sx={{
                      borderRadius: 2,
                      p: 2,
                      zIndex: 2,
                      position: 'relative',
                    }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          />

                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            New Mexico State Tax is Withheld
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            New Mexico State Tax is not Withheld
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{}}>
                        <TableRow sx={{ backgroundColor: 'transparent' }}>
                          <TableCell
                            sx={{
                              backgroundColor: 'transparent',
                              textAlign: 'center',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Taxes / Payments
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            More than $0 in taxes
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            $600 or more in payments
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Filing Method
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            CF/SF (Combined Federal/State Filing)
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Additional Form
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Not Required
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Not Required
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                            id="misc"
                          >
                            Due Date
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={12}
            sx={{
              textAlign: 'center',
              mt: { xs: 6, sm: 0 },
              mb: 4,
              position: { xs: 'relative', sm: 'static' },
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: { xs: 'flex', sm: 'grid', md: 'grid' },
                gridTemplateColumns: 'auto auto ',
                columnGap: 1,
                placeContent: 'start',
                m: { xs: 3, sm: 0 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: '#efefef',
                  height: 150,
                  width: 150,
                  position: { xs: 'absolute', sm: 'relative', md: 'relative' },
                  left: { md: 55, sm: 40, xs: 90 },
                  zIndex: 2,
                  top: { xs: -80, sm: 0 },
                  p: 3,
                  m: '0',
                  boxShadow:
                    'rgba(154, 154, 163, 0.25) 0px 30px 50px -12px inset, rgba(255, 255, 255, 0.1) 0px 18px 26px -18px inset',
                }}
              >
                <Box
                  sx={{
                    width: '34px !important',
                    height: '27px !important',
                    m: 'auto',
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    mb: 0.5,
                    // position: 'relative',
                    // mb: 2,

                    // alignSelf: 'center',
                    // textAlign: 'center',

                    '& .state-flag': {
                      // position: 'absolute',
                      height: '100%',
                      width: '100%',
                      // inset: '0px',
                      // color: 'transparent',
                    },
                  }}
                >
                  <img
                    srcSet="/assets/images/state-flag/new-mexico-flag.svg"
                    loading="lazy"
                    alt="new mexico"
                    width="100%"
                    height="100%"
                    className="state-flag"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 700,
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 0,
                    // display: 'flex',
                  }}
                >
                  1099-MISC
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#f0f2f9',

                  borderRadius: 4,
                  justifyContent: { xs: 'center' },
                  position: 'relative',
                  width: { xs: 331, sm: 'auto' },
                  right: { xs: 23, sm: 'auto' },
                }}
              >
                <Box
                  component="div"
                  sx={{ mb: 0, mx: 4, position: 'relative' }}
                  className="rectange-state rectange-state-left"
                >
                  <TableContainer
                    sx={{
                      borderRadius: 2,
                      p: 2,
                      zIndex: 2,
                      position: 'relative',
                    }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          />

                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            New Mexico State Tax is Withheld
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            New Mexico State Tax is not Withheld
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{}}>
                        <TableRow sx={{ backgroundColor: 'transparent' }}>
                          <TableCell
                            sx={{
                              backgroundColor: 'transparent',
                              textAlign: 'center',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Taxes / Payments
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            More than $0 in taxes
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            $600 or more in payments
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Filing Method
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            CF/SF (Combined Federal/State Filing)
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Additional Form
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Not Required
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Not Required
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                            id="1099b"
                          >
                            Due Date
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={12}
            sx={{
              textAlign: 'center',
              mb: 4,
              mt: { xs: 6, sm: 0 },
              position: { xs: 'relative', sm: 'static' },
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: { xs: 'flex', sm: 'grid', md: 'grid' },
                gridTemplateColumns: 'auto auto ',
                columnGap: 1,
                placeContent: 'start',
                m: { xs: 3, sm: 0 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: '#efefef',
                  height: 150,
                  width: 150,
                  position: { xs: 'absolute', sm: 'relative', md: 'relative' },
                  left: { md: 55, sm: 40, xs: 90 },
                  zIndex: 2,
                  top: { xs: -80, sm: 0 },
                  p: 3,
                  m: '0',
                  boxShadow:
                    'rgba(154, 154, 163, 0.25) 0px 30px 50px -12px inset, rgba(255, 255, 255, 0.1) 0px 18px 26px -18px inset',
                }}
              >
                <Box
                  sx={{
                    width: '34px !important',
                    height: '27px !important',
                    m: 'auto',
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    mb: 0.5,

                    '& .state-flag': {
                      height: '100%',
                      width: '100%',
                    },
                  }}
                >
                  <img
                    srcSet="/assets/images/state-flag/new-mexico-flag.svg"
                    loading="lazy"
                    alt="new mexico"
                    width="100%"
                    height="100%"
                    className="state-flag"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 700,
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 0,
                  }}
                >
                  1099-B
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#f0f2f9',

                  borderRadius: 4,
                  justifyContent: { xs: 'center' },
                  position: 'relative',
                  width: { xs: 331, sm: 'auto' },
                  right: { xs: 23, sm: 'auto' },
                }}
              >
                <Box
                  component="div"
                  sx={{ mb: 0, mx: 4, position: 'relative' }}
                  className="rectange-state rectange-state-left"
                >
                  <TableContainer
                    sx={{
                      borderRadius: 2,
                      p: 2,
                      zIndex: 2,
                      position: 'relative',
                    }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          />

                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            New Mexico State Tax is Withheld
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            New Mexico State Tax is not Withheld
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{}}>
                        <TableRow sx={{ backgroundColor: 'transparent' }}>
                          <TableCell
                            sx={{
                              backgroundColor: 'transparent',
                              textAlign: 'center',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Taxes / Payments
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            More than $0 in taxes
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            All amounts
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Filing Method
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            CF/SF (Combined Federal/State Filing)
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Additional Form
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Not Required
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Not Required
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                            id="div"
                          >
                            Due Date
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={12}
            sx={{
              textAlign: 'center',
              mb: 4,
              mt: { xs: 6, sm: 0 },
              position: { xs: 'relative', sm: 'static' },
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: { xs: 'flex', sm: 'grid', md: 'grid' },
                gridTemplateColumns: 'auto auto ',
                columnGap: 1,
                placeContent: 'start',
                m: { xs: 3, sm: 0 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: '#efefef',
                  height: 150,
                  width: 150,
                  position: { xs: 'absolute', sm: 'relative', md: 'relative' },
                  left: { md: 55, sm: 40, xs: 90 },
                  zIndex: 2,
                  top: { xs: -80, sm: 0 },
                  p: 3,
                  m: '0',
                  boxShadow:
                    'rgba(154, 154, 163, 0.25) 0px 30px 50px -12px inset, rgba(255, 255, 255, 0.1) 0px 18px 26px -18px inset',
                }}
              >
                <Box
                  sx={{
                    width: '34px !important',
                    height: '27px !important',
                    m: 'auto',
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    mb: 0.5,
                    // position: 'relative',
                    // mb: 2,

                    // alignSelf: 'center',
                    // textAlign: 'center',

                    '& .state-flag': {
                      // position: 'absolute',
                      height: '100%',
                      width: '100%',
                      // inset: '0px',
                      // color: 'transparent',
                    },
                  }}
                >
                  <img
                    srcSet="/assets/images/state-flag/new-mexico-flag.svg"
                    loading="lazy"
                    alt="new mexico"
                    width="100%"
                    height="100%"
                    className="state-flag"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 700,
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 0,
                    // display: 'flex',
                  }}
                >
                  1099-DIV
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#f0f2f9',

                  borderRadius: 4,
                  justifyContent: { xs: 'center' },
                  position: 'relative',
                  width: { xs: 331, sm: 'auto' },
                  right: { xs: 23, sm: 'auto' },
                }}
              >
                <Box
                  component="div"
                  sx={{ mb: 0, mx: 4, position: 'relative' }}
                  className="rectange-state rectange-state-left"
                >
                  <TableContainer
                    sx={{
                      borderRadius: 2,
                      p: 2,
                      zIndex: 2,
                      position: 'relative',
                    }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          />

                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            New Mexico State Tax is Withheld
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            New Mexico State Tax is not Withheld
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{}}>
                        <TableRow sx={{ backgroundColor: 'transparent' }}>
                          <TableCell
                            sx={{
                              backgroundColor: 'transparent',
                              textAlign: 'center',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Taxes / Payments
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            More than $0 in taxes
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            $10 or more, except $600 or more for liquidations
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Filing Method
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            CF/SF (Combined Federal/State Filing)
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Additional Form
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Not Required
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Not Required
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                            id="1099g"
                          >
                            Due Date
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={12}
            sx={{
              textAlign: 'center',
              mb: 4,
              mt: { xs: 6, sm: 0 },
              position: { xs: 'relative', sm: 'static' },
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: { xs: 'flex', sm: 'grid', md: 'grid' },
                gridTemplateColumns: 'auto auto ',
                columnGap: 1,
                placeContent: 'start',
                m: { xs: 3, sm: 0 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: '#efefef',
                  height: 150,
                  width: 150,
                  position: { xs: 'absolute', sm: 'relative', md: 'relative' },
                  left: { md: 55, sm: 40, xs: 90 },
                  zIndex: 2,
                  top: { xs: -80, sm: 0 },
                  p: 3,
                  m: '0',
                  boxShadow:
                    'rgba(154, 154, 163, 0.25) 0px 30px 50px -12px inset, rgba(255, 255, 255, 0.1) 0px 18px 26px -18px inset',
                }}
              >
                <Box
                  sx={{
                    width: '34px !important',
                    height: '27px !important',
                    m: 'auto',
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    mb: 0.5,

                    '& .state-flag': {
                      height: '100%',
                      width: '100%',
                    },
                  }}
                >
                  <img
                    srcSet="/assets/images/state-flag/new-mexico-flag.svg"
                    loading="lazy"
                    alt="new mexico"
                    width="100%"
                    height="100%"
                    className="state-flag"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 700,
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 0,
                  }}
                >
                  1099-G
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#f0f2f9',

                  borderRadius: 4,
                  justifyContent: { xs: 'center' },
                  position: 'relative',
                  width: { xs: 331, sm: 'auto' },
                  right: { xs: 23, sm: 'auto' },
                }}
              >
                <Box
                  component="div"
                  sx={{ mb: 0, mx: 4, position: 'relative' }}
                  className="rectange-state rectange-state-left"
                >
                  <TableContainer
                    sx={{
                      borderRadius: 2,
                      p: 2,
                      zIndex: 2,
                      position: 'relative',
                    }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          />

                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            New Mexico State Tax is Withheld
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            New Mexico State Tax is not Withheld
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{}}>
                        <TableRow sx={{ backgroundColor: 'transparent' }}>
                          <TableCell
                            sx={{
                              backgroundColor: 'transparent',
                              textAlign: 'center',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Taxes / Payments
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            More than $0 in taxes
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            $10 or more in payments
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Filing Method
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            CF/SF (Combined Federal/State Filing)
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Additional Form
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Not Required
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Not Required
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                            id="int"
                          >
                            Due Date
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={12}
            sx={{
              textAlign: 'center',
              mb: 4,
              mt: { xs: 6, sm: 0 },
              position: { xs: 'relative', sm: 'static' },
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: { xs: 'flex', sm: 'grid', md: 'grid' },
                gridTemplateColumns: 'auto auto ',
                columnGap: 1,
                placeContent: 'start',
                m: { xs: 3, sm: 0 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: '#efefef',
                  height: 150,
                  width: 150,
                  position: { xs: 'absolute', sm: 'relative', md: 'relative' },
                  left: { md: 55, sm: 40, xs: 90 },
                  zIndex: 2,
                  top: { xs: -80, sm: 0 },
                  p: 3,
                  m: '0',
                  boxShadow:
                    'rgba(154, 154, 163, 0.25) 0px 30px 50px -12px inset, rgba(255, 255, 255, 0.1) 0px 18px 26px -18px inset',
                }}
              >
                <Box
                  sx={{
                    width: '34px !important',
                    height: '27px !important',
                    m: 'auto',
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    mb: 0.5,
                    // position: 'relative',
                    // mb: 2,

                    // alignSelf: 'center',
                    // textAlign: 'center',

                    '& .state-flag': {
                      // position: 'absolute',
                      height: '100%',
                      width: '100%',
                      // inset: '0px',
                      // color: 'transparent',
                    },
                  }}
                >
                  <img
                    srcSet="/assets/images/state-flag/new-mexico-flag.svg"
                    loading="lazy"
                    alt="new mexico"
                    width="100%"
                    height="100%"
                    className="state-flag"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 700,
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 0,
                    // display: 'flex',
                  }}
                >
                  1099-INT
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#f0f2f9',

                  borderRadius: 4,
                  justifyContent: { xs: 'center' },
                  position: 'relative',
                  width: { xs: 331, sm: 'auto' },
                  right: { xs: 23, sm: 'auto' },
                }}
              >
                <Box
                  component="div"
                  sx={{ mb: 0, mx: 4, position: 'relative' }}
                  className="rectange-state rectange-state-left"
                >
                  <TableContainer
                    sx={{
                      borderRadius: 2,
                      p: 2,
                      zIndex: 2,
                      position: 'relative',
                    }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          />

                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            New Mexico State Tax is Withheld
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            New Mexico State Tax is not Withheld
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{}}>
                        <TableRow sx={{ backgroundColor: 'transparent' }}>
                          <TableCell
                            sx={{
                              backgroundColor: 'transparent',
                              textAlign: 'center',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Taxes / Payments
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            More than $0 in taxes
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            $10 or more in payments($600 or more in certain
                            circumstances)
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Filing Method
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            CF/SF (Combined Federal/State Filing)
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Additional Form
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Not Required
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Not Required
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                            id="1099k"
                          >
                            Due Date
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={12}
            sx={{
              textAlign: 'center',
              mb: 4,
              mt: { xs: 6, sm: 0 },
              position: { xs: 'relative', sm: 'static' },
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: { xs: 'flex', sm: 'grid', md: 'grid' },
                gridTemplateColumns: 'auto auto ',
                columnGap: 1,
                placeContent: 'start',
                m: { xs: 3, sm: 0 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: '#efefef',
                  height: 150,
                  width: 150,
                  position: { xs: 'absolute', sm: 'relative', md: 'relative' },
                  left: { md: 55, sm: 40, xs: 90 },
                  zIndex: 2,
                  top: { xs: -80, sm: 0 },
                  p: 3,
                  m: '0',
                  boxShadow:
                    'rgba(154, 154, 163, 0.25) 0px 30px 50px -12px inset, rgba(255, 255, 255, 0.1) 0px 18px 26px -18px inset',
                }}
              >
                <Box
                  sx={{
                    width: '34px !important',
                    height: '27px !important',
                    m: 'auto',
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    mb: 0.5,

                    '& .state-flag': {
                      height: '100%',
                      width: '100%',
                    },
                  }}
                >
                  <img
                    srcSet="/assets/images/state-flag/new-mexico-flag.svg"
                    loading="lazy"
                    alt="new mexico"
                    width="100%"
                    height="100%"
                    className="state-flag"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 700,
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 0,
                  }}
                >
                  1099-K
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#f0f2f9',

                  borderRadius: 4,
                  justifyContent: { xs: 'center' },
                  position: 'relative',
                  width: { xs: 331, sm: 'auto' },
                  right: { xs: 23, sm: 'auto' },
                }}
              >
                <Box
                  component="div"
                  sx={{ mb: 0, mx: 4, position: 'relative' }}
                  className="rectange-state rectange-state-left"
                >
                  <TableContainer
                    sx={{
                      borderRadius: 2,
                      p: 2,
                      zIndex: 2,
                      position: 'relative',
                    }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          />

                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            New Mexico State Tax is Withheld
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            New Mexico State Tax is not Withheld
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{}}>
                        <TableRow sx={{ backgroundColor: 'transparent' }}>
                          <TableCell
                            sx={{
                              backgroundColor: 'transparent',
                              textAlign: 'center',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Taxes / Payments
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            More than $0 in taxes
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'left',
                              backgroundColor: 'transparent',
                            }}
                          >
                            <ul>
                              <li>
                                $600 or more for third-party network
                                transactions.
                              </li>
                              <li>
                                All amounts for payment card transactions.
                              </li>
                            </ul>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Filing Method
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            CF/SF (Combined Federal/State Filing)
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Additional Form
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Not Required
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Not Required
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                            id="oid"
                          >
                            Due Date
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={12}
            sx={{
              textAlign: 'center',
              mb: 4,
              mt: { xs: 6, sm: 0 },
              position: { xs: 'relative', sm: 'static' },
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: { xs: 'flex', sm: 'grid', md: 'grid' },
                gridTemplateColumns: 'auto auto ',
                columnGap: 1,
                placeContent: 'start',
                m: { xs: 3, sm: 0 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: '#efefef',
                  height: 150,
                  width: 150,
                  position: { xs: 'absolute', sm: 'relative', md: 'relative' },
                  left: { md: 55, sm: 40, xs: 90 },
                  zIndex: 2,
                  top: { xs: -80, sm: 0 },
                  p: 3,
                  m: '0',
                  boxShadow:
                    'rgba(154, 154, 163, 0.25) 0px 30px 50px -12px inset, rgba(255, 255, 255, 0.1) 0px 18px 26px -18px inset',
                }}
              >
                <Box
                  sx={{
                    width: '34px !important',
                    height: '27px !important',
                    m: 'auto',
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    mb: 0.5,
                    // position: 'relative',
                    // mb: 2,

                    // alignSelf: 'center',
                    // textAlign: 'center',

                    '& .state-flag': {
                      // position: 'absolute',
                      height: '100%',
                      width: '100%',
                      // inset: '0px',
                      // color: 'transparent',
                    },
                  }}
                >
                  <img
                    srcSet="/assets/images/state-flag/new-mexico-flag.svg"
                    loading="lazy"
                    alt="new mexico"
                    width="100%"
                    height="100%"
                    className="state-flag"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 700,
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 0,
                    // display: 'flex',
                  }}
                >
                  1099-OID
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#f0f2f9',

                  borderRadius: 4,
                  justifyContent: { xs: 'center' },
                  position: 'relative',
                  width: { xs: 331, sm: 'auto' },
                  right: { xs: 23, sm: 'auto' },
                }}
              >
                <Box
                  component="div"
                  sx={{ mb: 0, mx: 4, position: 'relative' }}
                  className="rectange-state rectange-state-left"
                >
                  <TableContainer
                    sx={{
                      borderRadius: 2,
                      p: 2,
                      zIndex: 2,
                      position: 'relative',
                    }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          />

                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            New Mexico State Tax is Withheld
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            New Mexico State Tax is not Withheld
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{}}>
                        <TableRow sx={{ backgroundColor: 'transparent' }}>
                          <TableCell
                            sx={{
                              backgroundColor: 'transparent',
                              textAlign: 'center',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Taxes / Payments
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            More than $0 in taxes
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            $10 or more in payments
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Filing Method
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            CF/SF (Combined Federal/State Filing)
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Additional Form
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Not Required
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Not Required
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                            id="1099r"
                          >
                            Due Date
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={12}
            sx={{
              textAlign: 'center',
              mb: 4,
              mt: { xs: 6, sm: 0 },
              position: { xs: 'relative', sm: 'static' },
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: { xs: 'flex', sm: 'grid', md: 'grid' },
                gridTemplateColumns: 'auto auto ',
                columnGap: 1,
                placeContent: 'start',
                m: { xs: 3, sm: 0 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: '#efefef',
                  height: 150,
                  width: 150,
                  position: { xs: 'absolute', sm: 'relative', md: 'relative' },
                  left: { md: 55, sm: 40, xs: 90 },
                  zIndex: 2,
                  top: { xs: -80, sm: 0 },
                  p: 3,
                  m: '0',
                  boxShadow:
                    'rgba(154, 154, 163, 0.25) 0px 30px 50px -12px inset, rgba(255, 255, 255, 0.1) 0px 18px 26px -18px inset',
                }}
              >
                <Box
                  sx={{
                    width: '34px !important',
                    height: '27px !important',
                    m: 'auto',
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    mb: 0.5,

                    '& .state-flag': {
                      height: '100%',
                      width: '100%',
                    },
                  }}
                >
                  <img
                    srcSet="/assets/images/state-flag/new-mexico-flag.svg"
                    loading="lazy"
                    alt="new mexico"
                    width="100%"
                    height="100%"
                    className="state-flag"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 700,
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 0,
                  }}
                >
                  1099-R
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#f0f2f9',

                  borderRadius: 4,
                  justifyContent: { xs: 'center' },
                  position: 'relative',
                  width: { xs: 331, sm: 'auto' },
                  right: { xs: 23, sm: 'auto' },
                }}
              >
                <Box
                  component="div"
                  sx={{ mb: 0, mx: 4, position: 'relative' }}
                  className="rectange-state rectange-state-left"
                >
                  <TableContainer
                    sx={{
                      borderRadius: 2,
                      p: 2,
                      zIndex: 2,
                      position: 'relative',
                    }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          />

                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            New Mexico State Tax is Withheld
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            New Mexico State Tax is not Withheld
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{}}>
                        <TableRow sx={{ backgroundColor: 'transparent' }}>
                          <TableCell
                            sx={{
                              backgroundColor: 'transparent',
                              textAlign: 'center',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Taxes / Payments
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            More than $0 in taxes
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                            }}
                          >
                            $10 or more in payments
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Filing Method
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            CF/SF (Combined Federal/State Filing)
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Additional Form
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Not Required
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Not Required
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                            id="w2g"
                          >
                            Due Date
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={12}
            sx={{
              textAlign: 'center',
              mb: 4,
              mt: { xs: 6, sm: 0 },
              position: { xs: 'relative', sm: 'static' },
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: { xs: 'flex', sm: 'grid', md: 'grid' },
                gridTemplateColumns: 'auto auto ',
                columnGap: 1,
                placeContent: 'start',
                m: { xs: 3, sm: 0 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: '#efefef',
                  height: 150,
                  width: 150,
                  position: { xs: 'absolute', sm: 'relative', md: 'relative' },
                  left: { md: 55, sm: 40, xs: 90 },
                  zIndex: 2,
                  top: { xs: -80, sm: 0 },
                  p: 3,
                  m: '0',
                  boxShadow:
                    'rgba(154, 154, 163, 0.25) 0px 30px 50px -12px inset, rgba(255, 255, 255, 0.1) 0px 18px 26px -18px inset',
                }}
              >
                <Box
                  sx={{
                    width: '34px !important',
                    height: '27px !important',
                    m: 'auto',
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    mb: 0.5,
                    // position: 'relative',
                    // mb: 2,

                    // alignSelf: 'center',
                    // textAlign: 'center',

                    '& .state-flag': {
                      // position: 'absolute',
                      height: '100%',
                      width: '100%',
                      // inset: '0px',
                      // color: 'transparent',
                    },
                  }}
                >
                  <img
                    srcSet="/assets/images/state-flag/new-mexico-flag.svg"
                    loading="lazy"
                    alt="new mexico"
                    width="100%"
                    height="100%"
                    className="state-flag"
                  />
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 700,
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 0,
                    // display: 'flex',
                  }}
                >
                  W-2G
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#f0f2f9',

                  borderRadius: 4,
                  justifyContent: { xs: 'center' },
                  position: 'relative',
                  width: { xs: 331, sm: 'auto' },
                  right: { xs: 23, sm: 'auto' },
                }}
              >
                <Box
                  component="div"
                  sx={{ mb: 0, mx: 4, position: 'relative' }}
                  className="rectange-state rectange-state-left"
                >
                  <TableContainer
                    sx={{
                      borderRadius: 2,
                      p: 2,
                      zIndex: 2,
                      position: 'relative',
                    }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          />

                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            New Mexico State Tax is Withheld
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              fontWeight: 600,
                              width: 300,

                              borderBottom: '1px solid #828282',
                              textAlign: 'center',
                            }}
                          >
                            New Mexico State Tax is not Withheld
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{}}>
                        <TableRow sx={{ backgroundColor: 'transparent' }}>
                          <TableCell
                            sx={{
                              backgroundColor: 'transparent',
                              textAlign: 'center',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Taxes / Payments
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            More than $0 in taxes
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'left',
                              backgroundColor: 'transparent',
                            }}
                          >
                            <ul>
                              <li>
                                $600 or more from general gambling activities
                              </li>
                              <li>
                                $1,200 or more from bingo or slot machines
                              </li>
                              <li>$1,500 or more from keno</li>
                            </ul>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Filing Method
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Direct Filing
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Additional Form
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Not Required
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Not Required
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              backgroundColor: 'transparent',
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            Due Date
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            February 02, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid size={12} sx={{ textAlign: 'center' }}>
            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 600,

                mb: 2,
                lineHeight: 1.5,
              }}
            >
              Get started with 1099 E-filing in New Mexico today!
            </Typography>
            <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
              <Button
                variant="contained"
                className="btn-primary"
                sx={{
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099nm`}
              >
                Start Filing Now!{' '}
                {/* <Box
                      component={'span'}
                      sx={{ ml: 1, color: '#eaff00', fontWeight: 700 }}
                    >
                      Your W-2 Today!
                    </Box> */}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            direction={{ md: 'row', xs: 'column-reverse' }}
            sx={{ pt: 5, pb: 5 }}
          >
            <Grid
              size={{ xs: 12, sm: 6 }}
              sx={{
                textAlign: { md: 'left', xs: 'center' },
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <Box sx={{ px: { md: 0, sm: 0, xs: 2 } }}>
                {' '}
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: { md: 3, sm: 1, xs: 0 },
                    pt: { md: 0, sm: 3 },
                    textAlign: { md: 'left', sm: 'center' },
                  }}
                >
                  Who needs to File 1099 Forms in New Mexico?
                </Typography>
                <Typography variant="body1">
                  In New Mexico, businesses that withhold state income tax are
                  obligated to file 1099 forms for the 2025 tax year. This
                  requirement applies to all types of businesses, from sole
                  proprietors to large corporations. Ensuring timely and
                  accurate submission of these forms helps businesses comply
                  with New Mexico state regulations and avoid penalties.
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }} sx={{ textAlign: 'center' }}>
              <Box>
                <picture>
                  <source srcSet="/assets/images/who-file-nm-img.webp" />
                  <source srcSet="/assets/images/who-file-nm-img.png" />
                  <img
                    src="/assets/images/who-file-nm-img.png"
                    alt="Who needs to File 1099 Forms in New Mexico?"
                    className="img-responsive img-shadow"
                    loading="lazy"
                    width={400}
                    height={400}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ py: 6 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mt: 4,
              mb: 2,
              textAlign: 'center',
            }}
          >
            Why Choose TaxZerone for New Mexico 1099 Filing?
          </Typography>
          <Typography
            variant="body1"
            sx={{ px: { md: 14, sm: 3, xs: 2 }, textAlign: 'center', mb: 3 }}
          >
            Streamline your New Mexico 1099 filing with TaxZerone. Our
            easy-to-use platform{' '}
            <Hidden smDown>
              {' '}
              <br />
            </Hidden>
            ensures quick, accurate, and hassle-free submissions.
          </Typography>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  backgroundColor: '#f0f2f9',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  p: 4,
                  borderRadius: 4,
                  textAlign: 'center',
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/easy-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/easy-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/easy-icon.png"
                      alt="Quick & Effortless Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: '18px !important',
                    mt: 2,
                    mb: 1,
                  }}
                >
                  Quick & Effortless Filing
                </Typography>
                <Typography variant="body1">
                  {' '}
                  Complete your 1099 filings in under 5 minutes with our
                  streamlined <br />
                  3-step process.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  backgroundColor: '#f0f2f9',
                  borderColor: '#76ce97',
                  borderWidth: 3,
                  p: 4,
                  borderRadius: 4,
                  textAlign: 'center',
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/lowest-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/lowest-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/lowest-icon.png"
                      alt="Affordable Pricing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: '18px !important',
                    mt: 2,
                    mb: 1,
                  }}
                >
                  Affordable Pricing
                </Typography>
                <Typography variant="body1">
                  {' '}
                  File your 1099 state forms for just <b>$0.99</b> each, with no
                  extra charges.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  backgroundColor: '#f0f2f9',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  p: 4,
                  borderRadius: 4,
                  textAlign: 'center',
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/upload-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/upload-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/upload-icon.png"
                      alt="Bulk Upload Made Easy"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: '18px !important',
                    mb: 1,
                    mt: 2,
                  }}
                >
                  Bulk Upload Made Easy
                </Typography>
                <Typography variant="body1">
                  {' '}
                  Save time by uploading multiple forms in one go.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  backgroundColor: '#f0f2f9',
                  p: 4,
                  borderRadius: 4,
                  textAlign: 'center',
                  minHeight: '100%',
                  borderWidth: 3,
                  borderColor: '#76ce97',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/support-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/support-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/support-icon.png"
                      alt="Reliable Expert Support"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: '18px !important',
                    mb: 1,
                    mt: 2,
                  }}
                >
                  Reliable Expert Support
                </Typography>
                <Typography variant="body1">
                  {' '}
                  Our dedicated team is here to help you with any questions or
                  challenges you may face.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box
        component="section"
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Effortlessly file your New Mexico 1099 forms with TaxZerone!
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          Our platform streamlines the process, offering both Electronic
          (Direct) Filing{' '}
          <Hidden smDown>
            <br />
          </Hidden>
          and the Combined Federal/State Filing (CF/SF) program for fast,{' '}
          <Hidden smDown>
            <br />
          </Hidden>
          accurate, and efficient submissions every time.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099nm`}
          >
            Get Started Today
          </Button>
        </Box>
      </Box>
      <Container component="section" maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
            className="responsive"
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. Which 1099 Forms Are Required for New Mexico State Tax
                  Filing?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      For New Mexico state tax filing, the following 1099 forms
                      are required:
                    </Typography>
                    <Box component="ul" sx={{ mb: 1, '& li': { mb: 0.6 } }}>
                      <li>
                        {' '}
                        <Link
                          href="/information-returns/efile-irs-form-1099-nec/"
                          sx={{ color: '#0202ff' }}
                        >
                          Form 1099-NEC
                        </Link>{' '}
                        – Nonemployee Compensation
                      </li>
                      <li>
                        <Link
                          href="/information-returns/efile-irs-form-1099-misc/"
                          sx={{ color: '#0202ff' }}
                        >
                          Form 1099-MISC
                        </Link>{' '}
                        – Miscellaneous Information
                      </li>
                      <li>
                        <Link
                          href="/information-returns/efile-irs-form-1099-b/"
                          sx={{ color: '#0202ff' }}
                        >
                          Form 1099-B
                        </Link>{' '}
                        – Proceeds from Broker and Barter Exchange Transactions
                      </li>
                      <li>
                        <Link
                          href="/information-returns/efile-irs-form-1099-div/"
                          sx={{ color: '#0202ff' }}
                        >
                          Form 1099-DIV
                        </Link>{' '}
                        – Dividends and Distributions
                      </li>
                      <li>
                        {' '}
                        <Link
                          href="/information-returns/efile-irs-form-1099-g/"
                          sx={{ color: '#0202ff' }}
                        >
                          Form 1099-G
                        </Link>{' '}
                        – Certain Government Payments
                      </li>
                      <li>
                        {' '}
                        <Link
                          href="/information-returns/efile-irs-form-1099-int/"
                          sx={{ color: '#0202ff' }}
                        >
                          Form 1099-INT
                        </Link>{' '}
                        – Interest Income
                      </li>
                      <li>
                        <Link
                          href="/information-returns/efile-irs-form-1099-k/"
                          sx={{ color: '#0202ff' }}
                        >
                          Form 1099-K
                        </Link>{' '}
                        – Payment Card and Third-Party Network Transactions
                      </li>
                      <li>
                        <Link
                          href="/information-returns/efile-irs-form-1099-oid/"
                          sx={{ color: '#0202ff' }}
                        >
                          Form 1099-OID
                        </Link>{' '}
                        – Original Issue Discount
                      </li>
                      <li>
                        <Link
                          href="/information-returns/efile-irs-form-1099-r/"
                          sx={{ color: '#0202ff' }}
                        >
                          Form 1099-R
                        </Link>{' '}
                        – Distributions from Pensions, Annuities, etc.
                      </li>
                      <li>
                        <Link
                          href="/information-returns/efile-irs-form-w-2g/"
                          sx={{ color: '#0202ff' }}
                        >
                          Form W-2G
                        </Link>{' '}
                        – Certain Gambling Winnings
                      </li>
                    </Box>
                    <Typography variant="body1">
                      {' '}
                      These forms are required for reporting various types of
                      income and withholding for New Mexico state taxes.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. Is there any additional form required for New Mexico State
                  Filing?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      No, there is no additional form required specifically for
                      New Mexico state filing beyond the standard forms for
                      withholding, such as{' '}
                      <Link
                        href="/information-returns/efile-irs-form-w2/"
                        sx={{ color: '#0202ff' }}
                      >
                        Form W-2
                      </Link>{' '}
                      or 1099 for income reporting.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. Who is Required to File 1099 Forms with New Mexico?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      Any business or payer that withholds New Mexico state
                      income tax from payments must file the relevant 1099 forms
                      with the New Mexico Department of Revenue. This includes
                      payments for non-employee compensation, rents, royalties,
                      or other reportable transactions. Accurate and timely
                      filing ensures compliance and avoids penalties.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. What are the New Mexico 1099 Filing Deadlines for the 2025
                  Tax Year?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      The deadline for filing 1099 forms with New Mexico, if
                      they include state income tax withholding, is{' '}
                      <span style={{ fontWeight: 600 }}>January 31, 2026</span>.
                      Forms without withholding are also due by this date. If
                      the deadline falls on a weekend or holiday, it is extended
                      to the next business day.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  5. What is the penalty for late filing or payment of Form 1099
                  in New Mexico?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      In New Mexico, a negligence penalty applies if you file
                      Form 1099 late or fail to pay the tax due on time. The
                      penalty is 2% of the tax due for each month, or part of a
                      month, the return is delayed or the tax remains unpaid,
                      with a maximum penalty of 20%.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  6. Where should paper-filed Form 1099 information returns be
                  sent in New Mexico?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1, mb: 1 }}>
                      Paper-filed Form 1099 information returns should be mailed
                      to the following address:
                    </Typography>
                    <Box sx={{ textAlign: 'left' }}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: 600, mb: 0.8 }}
                      >
                        {' '}
                        <MailOutlineOutlinedIcon
                          sx={{
                            position: 'relative',
                            ml: 0,
                            mr: 0.5,
                            mb: -1,
                            fontSize: 28,
                          }}
                        />{' '}
                        Mailing Address:
                      </Typography>
                      <Box
                        component="div"
                        sx={{ textAlign: 'left', fontSize: '15px important' }}
                      >
                        <Typography
                          variant="body2"
                          sx={{ fontStyle: 'italic' }}
                        >
                          <span style={{ fontWeight: 600 }}>
                            New Mexico Taxation and Revenue Department
                          </span>
                          <br />
                          P.O. Box 25128
                          <br />
                          Santa Fe, NM 87504-5128
                        </Typography>
                      </Box>
                    </Box>
                    <Alert severity="warning" icon={false} sx={{ mt: 2 }}>
                      <b>Note:</b> The IRS recommends e-filing for a fast,
                      secure and more convenient experience.
                    </Alert>
                  </Box>
                </Box>
              </Box>
            </Box>{' '}
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default Form1099NewJersey;
